<template>
  <div class="content-container">
    <!-- SEARCH COMPONENT -->
    <search-comp @onSearch="onSearch" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col w-33">
              <div class="das-form-input">
                <div class="label">
                  {{ $t('field.searchInformation') }}
                </div>
                <input v-model="searchParams.code" type="text" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :rows="rows"
        dom-layout="scroll"
        class="agGrid"
        @selectionChanged="onSelectPriceCate"
      />
    </div>

    <el-col class="bottom-btns-container">
      <div class="button-containers mb-0">
        <button
          :disabled="!enableDelete"
          class="btn primary small outline"
          @click="deletePriceCategory"
        >
          {{ $t('button.deleteCategory') }}
        </button>
        <button
          :disabled="!enableEdit"
          class="btn primary small"
          @click="fnOpenEditDialog"
        >
          {{ $t('button.modifyCategory') }}
        </button>
        <button class="btn primary small" @click="fnOpenAddDialog">
          {{ $t('button.addCategory') }}
        </button>
      </div>
    </el-col>
    <el-dialog
      :title="
        !isEditDialog
          ? $t('dialog.titleRateCategoryAdd')
          : $t('dialog.titleRateCategoryModify')
      "
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="520px"
    >
      <!-- <el-form :model="form">
        <el-form-item label="Mã danh mục">
          <el-input v-model="form.code" placeholder="Nhập thông tin" />
        </el-form-item>
        <el-form-item label="Mô tả">
          <el-input
            v-model="form.desc"
            type="textarea"
            placeholder="Nhập thông tin"
          />
        </el-form-item>
        <el-form-item style="margin: 10px 0" label="Đêm phòng tương đương">
          <el-input
            v-model="form.equivalent_room_night"
            style="width: 30%"
            placeholder="Nhập thông tin"
          />
          %
        </el-form-item>
        <el-form-item label="Thứ tự">
          <el-input
            v-model="form.order"
            style="width: 30%"
            placeholder="Nhập thông tin"
          />
        </el-form-item>
      </el-form> -->

      <!-- START FORM -->
      <div class="das-form-container">
        <validation-observer ref="formValidator">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <validation-provider
                    rules="required|max:20|no_special"
                    :name="$t('field.packageCategoryCode')"
                  >
                    <div class="label required">
                      {{ $t('field.packageCategoryCode') }}
                    </div>
                    <input
                      v-model="form.code"
                      :readonly="isEditDialog"
                      type="text"
                    />
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">
                    {{ $t('field.equivalentRoomNight') }}
                    <span class="font-size: 12px">(%)</span>
                  </div>
                  <validation-provider
                    :name="$t('field.equivalentRoomNight')"
                    rules="required|min_value:0|number|max_value:100"
                  >
                    <div class="flex align-center">
                      <input
                        v-model="form.equivalent_room_night"
                        v-numeric-only
                        type="number"
                      />
                    </div>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <validation-provider
                    rules="required|max:255"
                    :name="$t('field.desc')"
                  >
                    <div class="label required">
                      {{ $t('field.desc') }}
                    </div>
                    <textarea
                      v-model="form.desc"
                      rows="3"
                      style="width: 100%"
                    />
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <!-- <div class="das-form-col col-6">
                <div class="das-form-input">
                  <validation-provider
                    :name="$t('field.order')"
                    rules="number|min_value:1"
                  >
                    <div class="label">
                      {{ $t('field.order') }}
                    </div>
                    <div>
                      <input
                        v-model="form.order"
                        v-numeric-only
                        type="number"
                        min="1"
                      />
                    </div>
                  </validation-provider>
                </div>
              </div> -->
            </div>
          </div>
        </validation-observer>
      </div>
      <!-- END FORM -->

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogFormVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button
            v-if="isEditDialog"
            class="btn primary small"
            @click="updatePriceCategory"
          >
            {{ $t('button.update') }}
          </button>
          <button v-else class="btn primary small" @click="addPriceCategoty">
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
// import bus from '@/utils/bus'
import {
  getPriceCategoryApi,
  deletePriceCategoryApi,
  addPriceCategoryApi,
  updatePriceCategoryApi
} from '@/api/Service_Policy/priceCategory'
import { Message } from 'element-ui'

const getDefaultForm = () => {
  return {
    id: null,
    code: '',
    desc: '',
    equivalent_room_night: null,
    order: null
  }
}

export default {
  data() {
    return {
      loading: false,
      form: {
        id: null,
        code: '',
        desc: '',
        equivalent_room_night: null,
        order: null
      },

      // FOR DISABLING BUTTONS
      enableEdit: false,
      enableDelete: false,

      isEditDialog: false,
      dialogFormVisible: false,
      searchParams: {
        code: null
      },

      columns: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: this.$t('grid.column.categoryCode'),
          field: 'code',
          // cellClass: "grid-cell-centered",
          minWidth: 100
        },
        {
          headerName: this.$t('grid.column.desc'),
          field: 'desc',
          tooltipField: 'desc',
          minWidth: 250,
          flex: 1
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.equivalentRoomNight') + ' %',
          field: 'equivalent_room_night',
          width: 200
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.order'),
          field: 'order',
          width: 100
          // cellClass: "grid-cell-centered",
        }
      ],
      rows: []
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetForm()
    }
  },

  mounted() {
    this.attachData()
  },
  methods: {
    onReset() {
      ;(this.searchParams = {
        code: null
      }),
        this.attachData()
    },
    onSearch() {
      this.attachData()
    },
    async attachData() {
      this.loading = true

      let data = await getPriceCategoryApi(this.searchParams)
      this.rows = data.data

      this.loading = false
    },
    async addPriceCategoty() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return

      addPriceCategoryApi(this.form)
        .then(res => {
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + res.message)
          })
          this.attachData()
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + err.response.data.message)
          })
        })
    },
    async updatePriceCategory() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return
      updatePriceCategoryApi(this.form)
        .then(res => {
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + res.message)
          })
          this.attachData()
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + err.response.data.message)
          })
        })
    },

    async deletePriceCategory() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      const id_list = rowsSelected.map(item => item.id)
      if (id_list.length == 0) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectPriceCategory')
        })
      } else {
        this.$vxConfirm(this.$t('alert.deletePriceCategory'), {
          resolveText: 'OK',
          rejectText: 'Cancel',
          resolve: () => {
            deletePriceCategoryApi({
              ids: id_list
            })
              .then(res => {
                this.$message({
                  type: 'success',
                  message: this.$t('successMsg.' + res.message)
                })
                this.attachData()
              })
              .catch(err => {
                this.$message({
                  type: 'error',
                  message: this.$t('errorMsg.' + err.response.data.message)
                })
              })
          }
        })
      }
    },

    onSelectPriceCate(rows) {
      this.enableEdit = rows?.length == 1
      this.enableDelete = !!rows.length
    },

    resetForm() {
      this.form = getDefaultForm()
    },

    // DIALOG
    fnOpenAddDialog() {
      this.isEditDialog = false
      this.dialogFormVisible = true
    },

    fnOpenEditDialog() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowSelected = gridApi.getSelectedRows()[0]
      this.isEditDialog = true
      this.dialogFormVisible = true
      this.form = { ...rowSelected }
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
